/* Falta Mina prompt

   Hovering the media reveals a 32px eye. Clicking it opens the prompt to the
   left. The copy button copies, and the icon becomes a tick.

   ============================================================
   THE CLOSING BUDGET

   Leaving an open bar used to take the best part of a second before anything
   faded, which read as the page being slow rather than the animation being
   deliberate. It was three waits stacked end to end:

     320ms  grace period before deciding you had left
     380ms  holding the surface while the contents collapsed
      80ms  the CSS delay before the surface itself faded

   Now 140 + 240 + 30. The grace period only has to survive a cursor clipping
   the corner, not a change of mind. The hold only has to cover most of the
   collapse, not all of it: letting the surface start to go while the last of
   the contents finish overlaps the two and reads as one movement rather than
   two queued ones.
   ============================================================

   ABANDONING IT UNWINDS IN ORDER. Moving the cursor off the media ends :hover
   instantly, so the bar would otherwise start dropping while the prompt was
   still collapsing. is-closing pins the surface for the length of the collapse,
   then releases it. Returning cancels both timers, or the bar would drop out
   from under a live hover.

   THE EYE IS THE TOGGLE, the copy button is separate. Copy only exists once the
   bar is open, so the prompt is on screen before anything can reach the
   clipboard.

   CLIPBOARD FALLBACK. navigator.clipboard needs a secure context and is not
   granted everywhere. When it is missing or refuses, a hidden textarea plus
   execCommand still works.

   THE EYE ONLY PLAYS WHEN VISIBLE, and only loads its source then.

   NOT ON MOBILE. CSS hides the bar below 990px; this skips wiring it up at
   all, so no listeners and no video exist there either. */

(function () {
  var MOBILE = window.matchMedia && window.matchMedia('(max-width: 989px)');
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var LEAVE_MS = 140;    // grace period before deciding you have left
  var COLLAPSE_MS = 240; // hold on the surface while the contents go

  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text);
    }

    return new Promise(function (resolve, reject) {
      try {
        var ta = document.createElement('textarea');
        ta.value = text;
        ta.setAttribute('readonly', '');
        ta.style.position = 'fixed';
        ta.style.opacity = '0';
        ta.style.pointerEvents = 'none';
        document.body.appendChild(ta);
        ta.select();
        var ok = document.execCommand('copy');
        document.body.removeChild(ta);
        ok ? resolve() : reject(new Error('copy refused'));
      } catch (e) { reject(e); }
    });
  }

  function init(root) {
    if (root.__fpInit) return;
    root.__fpInit = true;

    var eyeBtn = root.querySelector('.fp__eye-btn');
    var textEl = root.querySelector('.fp__text');
    var copyBtn = root.querySelector('.fp__copy');
    var eye = root.querySelector('.fp__eye');
    if (!eyeBtn || !textEl || !copyBtn) return;

    var doneTimer = null;
    var releaseTimer = null;

    function clearRelease() {
      if (releaseTimer) { clearTimeout(releaseTimer); releaseTimer = null; }
      root.classList.remove('is-closing');
    }

    /* Collapse the contents, hold the surface, then let it go. */
    function unwind() {
      if (!root.classList.contains('is-open')) return;

      root.classList.remove('is-open', 'is-copied');
      eyeBtn.setAttribute('aria-expanded', 'false');
      if (doneTimer) { clearTimeout(doneTimer); doneTimer = null; }

      root.classList.add('is-closing');
      if (releaseTimer) clearTimeout(releaseTimer);
      releaseTimer = setTimeout(function () {
        root.classList.remove('is-closing');
        releaseTimer = null;
      }, COLLAPSE_MS);
    }

    eyeBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      if (root.classList.contains('is-open')) { unwind(); return; }

      clearRelease();
      root.classList.add('is-open');
      eyeBtn.setAttribute('aria-expanded', 'true');
    });

    copyBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      copyText(textEl.textContent.trim()).then(function () {
        root.classList.add('is-copied');
        if (doneTimer) clearTimeout(doneTimer);
        doneTimer = setTimeout(function () { root.classList.remove('is-copied'); }, 1800);
      }).catch(function () {
        // Selecting it at least lets them copy by hand.
        try {
          var range = document.createRange();
          range.selectNodeContents(textEl);
          var sel = window.getSelection();
          sel.removeAllRanges();
          sel.addRange(range);
        } catch (err) {}
      });
    });

    root.addEventListener('click', function (e) { e.stopPropagation(); });
    document.addEventListener('click', unwind);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') unwind(); });

    /* Leaving the media unwinds it. Coming back cancels everything in flight. */
    var shell = root.closest('.js-media-shell') || root.parentElement;
    if (shell) {
      var leaveTimer = null;

      shell.addEventListener('mouseleave', function () {
        leaveTimer = setTimeout(unwind, LEAVE_MS);
      });

      shell.addEventListener('mouseenter', function () {
        if (leaveTimer) { clearTimeout(leaveTimer); leaveTimer = null; }
        clearRelease();
      });
    }

    /* The eye, playing only while on screen. */

    if (!eye) return;

    eye.muted = true;
    eye.loop = true;
    eye.playsInline = true;
    eye.setAttribute('muted', '');
    eye.setAttribute('playsinline', '');

    var src = eye.getAttribute('data-src');
    if (!src) return;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      eye.setAttribute('src', src);
      return;
    }

    new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) {
          if (!eye.getAttribute('src')) { eye.setAttribute('src', src); eye.load(); }
          var p = eye.play();
          if (p && p.catch) p.catch(function () {});
        } else {
          try { eye.pause(); } catch (e) {}
        }
      }
    }, { rootMargin: '200px 0px', threshold: 0.1 }).observe(root);
  }

  function start() {
    if (MOBILE && MOBILE.matches) return;
    var nodes = document.querySelectorAll('[data-falta-prompt]');
    for (var i = 0; i < nodes.length; i++) init(nodes[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  window.addEventListener('load', start);

  // Resizing a desktop window down and back up should not leave it dead.
  if (MOBILE && MOBILE.addEventListener) {
    MOBILE.addEventListener('change', function (e) { if (!e.matches) start(); });
  }
})();
